/*
 * Store a file in S3 and return its UUID, key, and other informations.
 * Using: https://github.com/laravel/vapor-js/blob/master/src/index.js
 */

const Vapor = require('laravel-vapor');

export default class s3 {
    constructor(token, apiBaseUrl) {
        this.apiBaseUrl = apiBaseUrl ? apiBaseUrl : process.env.VUE_APP_API_BASE_URL;
        this.token = token;
    }

    store(file) {
        this.file = file;
        this.progress = 0;

        return Vapor.store(this.file, {
            headers: { 'Authorization': `Bearer ${this.token}` },
            progress: progress => { this.progress = Math.round(progress * 100) },
            signedStorageUrl: `${this.apiBaseUrl}/vapor/signed-storage-url`
        });
    }
}
